<template>
  <div>
    <RegisterHeader @toLogin="toLogin" />
    <div class="Register">
      <h1>绑定手机号</h1>
      <div class="container">
        <div class="Img">
          <img src="../assets/images/蒙版组 150@2x.png" alt />
        </div>
        <p>用户授权成功，请先绑定手机号！</p>
        <el-form ref="ruleForm" :rules="rules" :model="ruleForm" class="Form" label-width="80px">
          <el-form-item label="手机号:" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button class="submitBtn" @click="onSubmit('ruleForm')" type="primary">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <Footer :spcial="true" />
    <Login ref="login" />
  </div>
</template>

<script>
import { postAction } from '../api/api'
import { WechatLogin } from '../api/url'
import Footer from '@/components/Footer'
import RegisterHeader from '@/components/RegisterHeader'
import Login from '@/components/Login'
export default {
  components: {
    Footer,
    RegisterHeader,
    Login,
  },
  data() {
    //验证手机号
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      }
      setTimeout(() => {
        var reg_tel =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/ //11位手机号码正则
        if (reg_tel.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号!'))
        }
      }, 100)
    }
    return {
      ruleForm: {
        phone: '',
      },
      rules: {
        phone: [
          {
            validator: checkPhone,
            trigger: 'blur',
          },
        ],
      },
      IsRegister: true,
    }
  },

  created() {},
  methods: {
    toLogin() {
      this.$refs.login.show()
    },
    onSubmit(FormName) {
      let vm = this
      this.$refs[FormName].validate((valid) => {
        if (valid) {
          let wxuserinfo = JSON.parse(localStorage.getItem('UserInfo'))
          wxuserinfo.action = 'bangdingwxuserinfo'
          wxuserinfo.phone = this.ruleForm.phone

          postAction(WechatLogin, this.$qs.stringify(wxuserinfo)).then(
            (res) => {
              //// console.log(res);
              if (res.status == 1) {
                this.$message({
                  showClose: false,
                  message: '用户绑定成功',
                  type: 'success',
                })
                setTimeout(() => {
                  this.$router.push('/')
                })
              } else {
                this.$confirm(res.errmsg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                })
                  .then(() => {
                    this.$router.push('/Register')
                  })
                  .catch(() => {})
              }
              vm.$refs[FormName].resetFields()
            }
          )
        }
      })
    },
    // 获取验证码
    getRandomNum() {
      let vm = this
      this.nums = ''
      for (var i = 0; i < 6; i++) {
        var random = Math.floor(Math.random() * 10)
        this.nums += random
      }
      return this.nums
      //////// console.log('自动生成随机数', vm.randomNum);
    },
  },
}
</script>

<style lang='scss' scoped>
.Register {
  position: absolute;
  top: 10.9375rem;
  left: 0;
  right: 0;

  h1 {
    margin-bottom: 3.25rem;
  }
}

.container {
  width: 87.5rem;
  height: 37.75rem;
  background: #ffffff;
  margin: 0 auto;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding-top: 3.75rem;

  .Img {
    width: 9.6875rem;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }

  p {
    margin: 1.875rem 0 5rem;
    font-size: 1.25rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333;
  }
}

h1 {
  font-size: 2.625rem;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 2.9375rem;
  color: #ffffff;
  margin: 0;
}

.el-row {
  width: 40.625rem;
  margin: 0 auto;
  color: #2769dc;
  font-size: 16px;
  font-family: Microsoft YaHei;
}

.Steps {
  width: 40.625rem;
  height: 5.25rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.25rem;
  font-family: Microsoft YaHei;
  color: #fff;

  div {
    width: 3rem;
    height: 3rem;
    background: #2769dc;
    border-radius: 50%;
    line-height: 3.1875rem;
  }

  .middle {
    width: 34.6875rem;
    height: 0.75rem;
    background: #e1e9f6;
    border-radius: 0;
  }

  .First {
    background: #97c3ff;
  }
}

.isFirst {
  color: #85b8fd;
}

.Form {
  width: 31.25rem;
  margin: 0 auto;
  text-align: left;
}

.active2 {
  background: #2769dc !important;
}

/deep/.el-select {
  width: 9.375rem;
  margin-right: 1.25rem;
}

/deep/.el-form-item__label::before {
  display: none;
}

.submitBtn {
  width: 23.5625rem;
  height: 3.125rem;
  background: #2769dc;
  opacity: 1;
  border-radius: 0.25rem;
}

/deep/ .el-form-item__content {
  width: 23.5625rem;
}
</style>
